import { useMemo } from 'react';

import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';

import type { DateRange } from '@cast/shared-types';

import {
  allFilters,
  defaultQueryParamKeys,
  DateRangeFilter,
} from '@cast/shared-date-ui';

const CLUSTERS_OVERVIEW_CHART_TIMEZONE = 'UTC';

export const useClustersOverviewDateRange = (): DateRange => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const from = searchParams.get(defaultQueryParamKeys.fromDate);
    const to = searchParams.get(defaultQueryParamKeys.toDate);
    const preset = searchParams.get(
      defaultQueryParamKeys.dateRangePreset
    ) as DateRangeFilter | null;
    const timezone =
      searchParams.get(defaultQueryParamKeys.timeZone) ||
      CLUSTERS_OVERVIEW_CHART_TIMEZONE;

    if (preset && preset in allFilters) {
      const range = allFilters[preset].date(timezone, false);
      return [dayjs(range.from), dayjs(range.to)];
    }

    if (from && to && dayjs(from).isValid() && dayjs(to).isValid()) {
      return [dayjs(from), dayjs(to)];
    }

    const defaultRange = allFilters[DateRangeFilter.Last30Days].date(
      timezone,
      false
    );
    return [dayjs(defaultRange.from), dayjs(defaultRange.to)];
  }, [searchParams]);
};

export const getClustersOverviewRangeIso = (
  range: DateRange
): { startTime: string; endTime: string } => ({
  startTime: range[0].toISOString(),
  endTime: range[1].toISOString(),
});
